import $ from 'jquery';
import 'slick-carousel';
import {isMobile} from '../utilities';
class CarouselMobile {
  constructor(element){
    this.$el = $(element);
    this.els = {
      slides : this.$el,
      counter : this.$el.find('.slide-count'),
    };
    this.isCards = this.$el.parent().hasClass('third-cards');
    this.cloneIndex = parseInt(this.$el.attr('data-clone'));
    this.autoplayDelay = 1000 * this.cloneIndex;
    this.slideCount = this.els.slides.parent().parent().data('slide-count');
    this.slickOptions = {
      arrows:false,
      infinite:true,
      initialSlide: this.cloneIndex * 2,
      dots: false,
      slidesToShow:1,
      waitForAnimate:false,
      vertical: true,
      autoplay: true,
      adaptiveHeight: true
    };

    if(this.isCards){
      this.slickOptions.infinite = false;
      this.slickOptions.vertical = false;
      this.slickOptions.centerMode = true;
      this.slickOptions.centerPadding = '40px';
      this.slickOptions.waitForAnimate = false;
      this.slickOptions.autoplay = false;
      this.slickOptions.slidesToScroll = 1;
      this.slickOptions.initialSlide = 0;
      this.slickOptions.dots = true;
    }

    this.buildCarousel();

    window.addEventListener('resize', function () {
      if (window.innerWidth <= 768 & this.els.slides.hasClass('slick-initialized') & this.els.slides.hasClass('slides-clone')) {
        this.destroyCarousel();
      } else if (window.innerWidth > 768 & !this.els.slides.hasClass('slick-initialized') & this.els.slides.hasClass('slides-clone')) {
        this.buildCarousel();
      }

      if (window.innerWidth <= 768 & !this.els.slides.hasClass('slick-initialized') & this.els.slides.hasClass('cards-content')){
        this.buildCarousel();
      } else if (window.innerWidth > 768 & this.els.slides.hasClass('slick-initialized') & this.els.slides.hasClass('cards-content')){
        this.destroyCarousel();
      }

    }.bind(this));
  }

  destroyCarousel() {
    if (this.els.slides.hasClass('slick-initialized')) {
      this.els.slides.slick('unslick');
    }
  }

  updateSlideCount() {
    let thisEls = this.els;
    thisEls.slides.on('init reInit afterChange', (event,slick, currentSlide)=>{
      let i = (currentSlide ? currentSlide : 0) + 1;
      thisEls.counter.text(i + '/' + slick.slideCount);
    });
  }

  buildCarousel() {
    let that = this;
    if(that.isCards){
      if(isMobile()){
        that.els.slides.slick(that.slickOptions);
      }
    } else {
      that.els.slides.slick(that.slickOptions).slick('slickPause');
      if(isMobile()){
        setTimeout(()=>{
          that.els.slides.slick('slickPlay');
        },that.autoplayDelay);
      }else{
        if (that.slideCount > 3) {
          setTimeout(()=>{
            that.els.slides.slick('slickPlay');
          },that.autoplayDelay);
        }
      }
    }
    that.$el.parent().removeClass('transparent');
  }
}

$('.carousel-mobile-component .slides-mobile').each( (index, element)=>{
  if(!$(element).parent().parent().hasClass('carousel-wrapper')){
    new CarouselMobile(element);
  }
});
